//angular imports
import { ChangeDetectionStrategy, Component, Signal, computed, input, signal } from '@angular/core';

//local imports
import { Messenger } from '@app/shared';

import {
  CatalogStatus
} from '@app/catalog-common';


@Component({
    selector: 'catalog-filter-item',
    templateUrl: './catalog-filter-item.component.html',
    styleUrl: './catalog-filter-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogFilterItemComponent {

  CatalogFilterType: typeof CatalogStatus = CatalogStatus;

  private isToggledVal = true;
  
  public toggleFilterChanged: Signal<boolean> = signal(false); //Signal<ToggleFilterMessage>;
  public type = input<CatalogStatus>();

  public isToggled = computed(() => {
    let toggledFilterChangedMessage = this.toggleFilterChanged();
    if (!toggledFilterChangedMessage) return this.isToggledVal;

    return this.isToggledVal;
  });

  public count = computed(() => {
    return 0;
  });

  public bgClass = computed(() => {
    let currentType = this.type();
    let isToggledVal = this.isToggled();

    switch (currentType) {
      case CatalogStatus.Active:
        return isToggledVal ? "bg-active-status" : "bg-gradient-grey";
      case CatalogStatus.Archived:
        return isToggledVal ? "bg-archived-status" : "bg-gradient-grey";
      default:
        return "";
    }    
  });

  public indicator = computed(() => {
    let currentType = this.type();

    switch (currentType) {
      case CatalogStatus.Active:
        return "check_circle";
      case CatalogStatus.Archived:
        return "do_not_disturb"
      default:
        return "";
    }
  });

  constructor(public messenger: Messenger) {        
    //this.toggleFilterChanged = this.messenger.getSignal(ToggleFilterMessage);
  }

  public toggleFilter() {
    //this.messenger.send(new ToggleFilterMessage(this.type(), this.isToggledVal));
  }
  
}


